<template>
  <ul class="enroll-info">
    <li class="row" v-for="(i,idx) in list" :key="idx">
      <span class="title">{{i.title}}</span>
      <span class="content">{{i.content}}</span>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'enroll-info',
  props: {
    list: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="stylus" scoped>
@import "../styles/variable.styl";
.enroll-info {
  .row {
    display: flex;
    .title {
      flex-shrink: 0;
      width: 160px;
    }
    .content {
      flex-shrink: 1;
    }
  }
}
</style>
